var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecipe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.764 23.24L18.7415 23.24C20.2061 23.24 21.4044 22.0012 21.4044 20.487V2.75303C21.4044 1.23887 20.2061 -1.28039e-07 18.7415 0L2.76399 1.3968e-06C1.29939 1.52484e-06 0.101072 1.23887 0.101074 2.75304V20.487C0.101074 22.0012 1.29939 23.24 2.764 23.24ZM4.09546 12.8704L17.4101 12.8704V15.6235L4.09546 15.6235L4.09546 12.8704ZM4.09546 17.2982L17.4101 17.2982V20.0513L4.09546 20.0513L4.09546 17.2982ZM11.9125 7.63985H14.6215V4.89748H11.9125V2.15511H9.20347V4.89748H6.49443V7.63985H9.20347V10.3822H11.9125V7.63985Z",
    fill: "#1756E8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipe);
export default __webpack_public_path__ + "static/media/recipe.9940f561.svg";
export { ForwardRef as ReactComponent };